export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    description: '',
    qty: 1,
    unit_rate: 0,
    item_edit: 0
}

export let dataProps = {
    id: 0,
    store_id: null,
    additional_notes: '', 
    generated_by_staff_id: 0,
    estimated_total_cost: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/lostDamaged/properties.js